// #D8E3E7
// #DDFFBC
// #91C788
// #52734D
// #191919


// color: 
// background-color: #bf1212;

import { createMuiTheme } from '@material-ui/core/styles';

const customTheme = (darkMode) =>

  createMuiTheme({

    palette: {
      type: darkMode ? 'dark' : 'light',
      primary: {
        main: darkMode ? '#DDFFBC' : '#91C788',
      },
      secondary: {
        main: darkMode ? '#DDFFBC' : '#91C788',
      },
    },
    overrides: {
      MuiTypography: {
        root: {
          wordBreak: 'break-word',
        },
      },
    },
  });
 
export default customTheme;
